import { getYear } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import { recalculateHourManagement } from 'RestAPIs/admin';

import { showSnackbar } from 'components/shared';

export const useStartRecalculationMutation = () => {
  const { t } = useTranslation();
  return useMutation(
    (yearDate: Date) => recalculateHourManagement(getYear(yearDate)),
    {
      onSuccess: () =>
        showSnackbar({
          severity: 'success',
          message: t(
            'adminPortal.realization.recalculateHourManagement.success'
          )
        }),
      onError: () =>
        showSnackbar({
          severity: 'error',
          message: t('adminPortal.realization.recalculateHourManagement.error')
        })
    }
  );
};
